import React, {useEffect, useRef, useState} from "react";
import { Container } from "./sections/Container";
import { ContainerWrapper } from "./sections/ContainerWrapper";
import { PayCard } from "./sections/PayCard";
import { DivWrapper } from "./sections/DivWrapper";
import { Pay } from "./sections/Pay";
import { PayWrapper } from "./sections/PayWrapper";
import { SectionComponentNode } from "./sections/SectionComponentNode";
import { Top } from "./sections/Top";
import "./style.css";
import {MobileAppGallery} from "./sections/MobileAppGallery";
import {initialiseRequest, saveUserProfileRequest, sendEmailForWebsiteRequest} from "../../../../utils/api";
import PayRemainPopup from "./sections/PayRemainPopup";
import {getSKUS} from "../../../../config/config";
import {formatCheeseName, relocateToPage, toTimestamp} from "../../../../utils/common";
import {DISCOUNT_TIME, HAS_SHOWN_SCRATCH_PRIZE, PAY_REMAIN_SHOWN, PAY_TIMER_START, USER_INFO, FROM_EMAIL_71_DISCOUNT, RESULT_CLICK_LOGGED} from "../../../../const/LocalStorage";
import PayMethodsPopup from "./sections/PayMethodsPopup";
import {showScratchOffPrize} from "../../../../components/ScratchOffPrize";
import {track} from "@glority/tracking-js-sdk";
import {updateReferrers} from "../../../../utils/localStorage";
import {User} from "../../../../domin/pay/User";
let timer;
const discountDuration = 10 * 60; // 10 minutes in seconds

const shouldShowScratchPrizeByDefault = (isMobile) => {
    if (typeof window === "undefined" || typeof localStorage === "undefined") {
        return false;
    }

    const fromEmail71 = localStorage.getItem(FROM_EMAIL_71_DISCOUNT);
    const hasShownScratchPrize = localStorage.getItem(HAS_SHOWN_SCRATCH_PRIZE) === 'true';
    return !hasShownScratchPrize && fromEmail71 !== 'true' && (isMobile || window.innerWidth < 981);
};

export const PayScreen = ({
    clickNext = () => {},
    clickPrev = () => {},
    setDisplayNav = () => {},
    data,
                              isMobile,
                              isCurPage,
                              logEvent,
    defaultSku = 0,
                            }) => {
    const SKUS = getSKUS();
    const scratchPrizePendingByDefault = shouldShowScratchPrizeByDefault(isMobile);
    const [showPopup, setShowPopup] = useState(false);
    const [inited, setInited] = useState(false);
    // 1（待显示）→ 0（显示中）→ -1（已关闭）
    const [recover, setRecover] = useState(() => {
        // 初始化时检查是否已经显示过挽留页
        const payRemainShown = localStorage.getItem(PAY_REMAIN_SHOWN);
        const payRemainClosed = localStorage.getItem('pay_remain_closed');
        return (payRemainShown === 'true' || payRemainClosed === 'true') ? -1 : 1;
    });
    const [curSku, setCurSku] = useState(SKUS[1]);
    const [time, setTime] = React.useState(599); // 09:59 in seconds
    const [curPriceIndex, setCurPriceIndex] = useState(1);
    const [displayTime, setDisplayTime] = useState("09:59");
    const [showRemainPopup, setShowRemainPopup] = useState(() => {
        // 根据localStorage中的PAY_REMAIN_SHOWN状态初始化
        const payRemainShown = localStorage.getItem(PAY_REMAIN_SHOWN);
        return payRemainShown !== 'true'; // 如果已经显示过，则不显示
    });
    const [isScratchPrizePending, setIsScratchPrizePending] = useState(scratchPrizePendingByDefault);

    const targetRef = useRef(null);
    const bottomRef = useRef(null);
    const scratchPrizeDelayRef = useRef(null);
    const hasTriggeredScratchPrizeRef = useRef(false);
    const questionnaireName = data?.getWorkoutName?.() || "weight-loss";


    const initUser = async () => {
        // 检查是否已经初始化过（通过判断用户信息是否存在）
        const userInfo = localStorage.getItem(USER_INFO);
        if (userInfo) {
            // Check if user is already VIP
            const user = new User();
            if (user.isVip()) {
                // VIP user, redirect based on email status
                if (user.isGuestUser()) {
                    relocateToPage("/signup");
                } else {
                    relocateToPage("/download");
                }
                return;
            }
            
            setInited(true);
            return;
        }

        try {
            const user = await initialiseRequest();
            
            // Check if user is already VIP
            if (user.isVip()) {
                // VIP user, redirect based on email status
                if (user.isGuestUser()) {
                    relocateToPage("/signup");
                } else {
                    relocateToPage("/download");
                }
                return;
            }
            
            setInited(true);
            if (data.curIndex > 0) {
                await sendEmailForWebsiteRequest(questionnaireName, user.getUserId(), data);
                logEvent("savesurveyresult_show", {id: user.getUserId()});
            }
            await saveUserProfileRequest(user.getUserId(), data);
        } catch (error) {
            console.error("initUser failed:", error);
        }
    };

    useEffect(() => {
        setDisplayTime(toTimestamp(time));
    }, [time])

    useEffect(() => {
        if (isCurPage) {

            updateReferrers("pay");
            
            // Only log result_click once (check localStorage)
            const resultClickLogged = localStorage.getItem(RESULT_CLICK_LOGGED);
            if (!resultClickLogged) {
                logEvent("result_click", {content: {
                    content: data.toPlainObject()
                    }});
                localStorage.setItem(RESULT_CLICK_LOGGED, 'true');
            }
            
            logEvent("page_exposure", {}, "pay", true);
        }
    }, [isCurPage])

    // 启动计时器的通用函数
    const startTimer = () => {
        if (isCurPage) {
            // 清除可能存在的旧计时器
            if (timer) {
                clearInterval(timer);
            }
            
            // 启动新的计时器
            timer = setInterval(() => {
                const timerStart = localStorage.getItem(PAY_TIMER_START);
                if (!timerStart) {
                    clearInterval(timer);
                    return;
                }
                
                const startTime = parseInt(timerStart);
                const currentTime = Math.floor(Date.now() / 1000);
                const elapsed = currentTime - startTime;
                const remainingTime = Math.max(0, discountDuration - elapsed);
                
                if (remainingTime <= 0) {
                    setTime(0);
                    setCurSku(SKUS[0]);
                    clearInterval(timer);
                    localStorage.setItem(DISCOUNT_TIME, 'true');
                } else {
                    setTime(remainingTime);
                }
            }, 1000);
        }
    }

    const revertTimer = () => {
        localStorage.removeItem(DISCOUNT_TIME);
        localStorage.setItem(PAY_TIMER_START, Math.floor(Date.now() / 1000).toString());
        setTime(discountDuration);
        
        // 重新启动计时器
        startTimer();
    }

    const clearScratchPrizeDelay = () => {
        if (scratchPrizeDelayRef.current) {
            clearTimeout(scratchPrizeDelayRef.current);
            scratchPrizeDelayRef.current = null;
        }
    };

    const showScratchPrizeOverlay = () => {
        clearScratchPrizeDelay();
        scratchPrizeDelayRef.current = window.setTimeout(() => {
            showScratchOffPrize({
                discount: `${SKUS[1].discount}`,
                planType: formatCheeseName(questionnaireName),
                userName: data?.userName,
                onComplete: () => {
                    localStorage.setItem(HAS_SHOWN_SCRATCH_PRIZE, "true");
                    setIsScratchPrizePending(false);
                    revertTimer();
                },
            });
        }, 300);
    };

    useEffect( () => {
        // 只有当前页时才初始化倒计时
        if (!isCurPage) return undefined;

        clearScratchPrizeDelay();

        const discountTime = localStorage.getItem(DISCOUNT_TIME);
        const timerStart = localStorage.getItem(PAY_TIMER_START);
        const fromEmail71 = localStorage.getItem(FROM_EMAIL_71_DISCOUNT); // 检查是否从邮件进来
        const hasShownScratchPrize = localStorage.getItem(HAS_SHOWN_SCRATCH_PRIZE) === 'true';
        const shouldShowScratchPrize = !hasShownScratchPrize && fromEmail71 !== 'true' && (isMobile || window.innerWidth < 981);
        setIsScratchPrizePending(shouldShowScratchPrize);

        // 初始化用户信息
        initUser();

        if (shouldShowScratchPrize && !hasTriggeredScratchPrizeRef.current) {
            hasTriggeredScratchPrizeRef.current = true;
            setCurSku(SKUS[1]);
            setTime(discountDuration);
            localStorage.removeItem(DISCOUNT_TIME);
            if (timer) {
                clearInterval(timer);
            }
            showScratchPrizeOverlay();
            return () => {
                clearScratchPrizeDelay();
                clearInterval(timer);
            };
        }
        
        // 先判断倒计时是否结束（无论是否邮件用户）
        if (discountTime) {
            setCurSku(SKUS[defaultSku]); // 倒计时结束，回到原价（defaultSku=0）
            setTime(0);
        } else {
            // 倒计时未结束的情况下，判断优惠等级
            if (fromEmail71 === 'true') {
                // 邮件用户直接71%优惠
                setCurSku(SKUS[2]);
                // 标记挽留页已显示，防止触发挽留弹窗
                localStorage.setItem(PAY_REMAIN_SHOWN, 'true');
                setRecover(-1); // 同步更新 recover 状态
                setShowRemainPopup(false); // 同步更新 showRemainPopup 状态
            } else if (recover === 1) {
                // 判断是否显示过挽留页
                setCurSku(SKUS[1]);
            } else {
                setCurSku(SKUS[2]);
            }

            
            // 检查是否有保存的计时器开始时间
            if (timerStart) {
                const startTime = parseInt(timerStart);
                const currentTime = Math.floor(Date.now() / 1000);
                const elapsed = currentTime - startTime;
                const remainingTime = Math.max(0, discountDuration - elapsed); // 10分钟倒计时
                
                if (remainingTime <= 0) {
                    setTime(0);
                    setCurSku(SKUS[0]);
                    localStorage.setItem(DISCOUNT_TIME, 'true');
                } else {
                    setTime(remainingTime);
                }
            } else {
                revertTimer();
            }

            startTimer();
            return () => {
                clearScratchPrizeDelay();
                clearInterval(timer);
            };
        }

        return () => {
            clearScratchPrizeDelay();
            clearInterval(timer);
        };
    }, [data, defaultSku, isCurPage, isMobile, recover, questionnaireName])

    // 监听弹窗显示状态，当弹窗显示时就启用优惠
    useEffect(() => {
        if (recover === 0 && showRemainPopup) {
            // 弹窗展示时立即启用优惠
            setCurSku(SKUS[2]);
            revertTimer();
            // 标记挽留页已显示
            localStorage.setItem(PAY_REMAIN_SHOWN, 'true');
        }
    }, [recover, showRemainPopup]);

    const closePopup = () => {
        //只显示一次
        if (recover >= 0) {
            setRecover(recover - 1);
        }
        setShowPopup(false);
    }
    const openPayPopup = () => {
        setRecover(recover - 1);
        setShowPopup(false);

        logEvent("openpaypopup_click", {
            string1: curSku.prices[curPriceIndex]?.getPrice(),
            string2: curSku.prices[curPriceIndex]?.week + ""
        }, "", true); // instantly = true
    }

    const scrollToTarget = () => {
        if (targetRef.current) {
            targetRef.current.scrollIntoView({
                behavior: 'smooth', // 平滑滚动 (可选，默认为 'auto' 瞬间滚动)
                block: 'start',     // 将元素顶部与滚动区域的顶部对齐 (可选)
                inline: 'nearest'   // 将元素最近的边缘与滚动区域的最近边缘对齐 (可选)
            });
        }
    };

    const scrollToBottom = () => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({
                behavior: 'smooth', // 平滑滚动 (可选，默认为 'auto' 瞬间滚动)
                block: 'start',     // 将元素顶部与滚动区域的顶部对齐 (可选)
                inline: 'nearest'   // 将元素最近的边缘与滚动区域的最近边缘对齐 (可选)
            });
        }
    };
    const updatePrice = (index) => {
        logEvent("sku_click", {
            sku: JSON.stringify(curSku.prices[curPriceIndex]?.sku) || "",
            string2: curSku.prices[curPriceIndex]?.getUniqueId() || "" // SKU ID
        }, "pay", true); // instantly = true
        setCurPriceIndex(index);
    }
    const updateShowPopup = (show) => {
        setShowPopup(show);
        logEvent("methodspopup_show", {
            sku: JSON.stringify(curSku.prices[curPriceIndex]?.sku) || "",
            price: parseFloat(curSku.prices[curPriceIndex]?.price) || 0,
            integer1: curSku.prices[curPriceIndex]?.week, // week
            percent: curSku.discount, // discount percentage
            string2: curSku.prices[curPriceIndex]?.getUniqueId() || "" // SKU ID
        }, 'pay', true); // instantly = true
    }

  return (
      <>
          <div className="pay-screen" data-model-id="16762:9245">
              {isCurPage && <Top sku={curSku} time={displayTime} scrollToTarget={scrollToTarget} showDiscountInfo={!isScratchPrizePending} />}
              <div className="contents">
                <div className="frame-19">
                  <Container data={data}/>
                  <Pay sku={curSku} time={displayTime} timeInSeconds={time} curPriceIndex={curPriceIndex} setCurPriceIndex={updatePrice} setShowPopup={updateShowPopup} scrollToBottom={scrollToBottom} logEvent={logEvent} targetRef={targetRef} showDiscountInfo={!isScratchPrizePending} showSkuModule={!isScratchPrizePending} />
                  <MobileAppGallery/>

                  <ContainerWrapper data={data} time={displayTime} sku={curSku} showDiscountInfo={!isScratchPrizePending} />
                  <DivWrapper data={data} />
                  <PayWrapper sku={curSku} time={displayTime} timeInSeconds={time} curPriceIndex={curPriceIndex} setCurPriceIndex={updatePrice} setShowPopup={updateShowPopup} scrollToBottom={scrollToBottom} logEvent={logEvent} showDiscountInfo={!isScratchPrizePending} showSkuModule={!isScratchPrizePending} />
                  <PayCard setDisplayNav={setDisplayNav} bottomRef={bottomRef} />
                  <SectionComponentNode />
                </div>
              </div>
          </div>
          {inited &&
          <PayMethodsPopup
              isMobile={isMobile}
              discount={curSku.discount}
              price={curSku.prices?.[curPriceIndex]}
              showPopup={showPopup}
              closePopup={closePopup}
              weightLossFormData={data}
              logEvent={logEvent}
          />}
          <PayRemainPopup
              userName={data?.userName}
              isMobile={isMobile}
              closePopup={closePopup}
              openPayPopup={openPayPopup}
              logEvent={logEvent}
              display={recover === 0 && showRemainPopup}
              curSku={curSku}
              curPriceIndex={curPriceIndex}
          />
      </>
  );
};
